module.exports = __webpack_public_path__ + "img/GB-WhatsApp-Web.b2b78725.webp";